import { render } from "./NewsDetail.vue?vue&type=template&id=e66e5956"
import script from "./NewsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDetail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/news/NewsDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e66e5956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e66e5956', __exports__)) {
    console.log('reload')
    api.reload('e66e5956', __exports__)
  }
  
  module.hot.accept("./NewsDetail.vue?vue&type=template&id=e66e5956", () => {
    console.log('re-render')
    api.rerender('e66e5956', render)
  })

}


export default __exports__